import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cipx-file-upload',
  templateUrl: 'file-upload.component.html',
  standalone: false,
})


export class FileUploadComponent implements OnInit{
  fileUrl!: string | null;
  uploadFile!: File | null;

  @Input() acceptedFileMimeTypes: string[] = [];
  @Input() currentConfig: FileUploadConfig = <FileUploadConfig>{caption:'', horizontal:true, noIcon: true, noButton: true};
  @Output() fileUploadChanged = new EventEmitter<File[]>();
  @Input() resetForm = false;
  @Input() isUploading = false;


  defaultConfig = <FileUploadConfig>({
    caption: `Drag and drop <br /> file here to upload.`,
    noIcon: false,
    horizontal: false,
    noButton: false,
  });
  @Input() multiple: boolean = false;

  handleChange(event: any) {
    // const file = event.target.files[0] as File;
    // this.fileUrl = URL.createObjectURL(file);
    // this.uploadFile = file;
    const files = event.target.files as File[];
    if (files.length > 0) {
      this.currentConfig.caption = `(${files.length}) File selected`;
      let fnames = '';
      //array methods are not supported
      for (const file of files) {
        fnames+= file.name + ', ';
      }

      this.currentConfig.caption += '<br>' +fnames;
    }
    this.fileUploadChanged.emit(files);
  }

  ngOnInit() {
    //console.log('reset', this.resetForm);
  }

}
export interface FileUploadConfig {
  caption?: string;
  noButton?: boolean;
  horizontal?: boolean;
  noIcon?: boolean;
}
